import * as types from './types';

const initialState = {
  GetBrandVisibility: {},
  PostBrandVisibility: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };
    case types.GET_BRAND_VISIBILITY_SUCCESS: {
      return {
        ...state,
        GetBrandVisibility: action.payload
      };
    }
    case types.GET_BRAND_VISIBILITY_FAILURE:
      return { ...state, error: action.payload };

    case types.POST_BRAND_VISIBILITY_SUCCESS: {
      return {
        ...state,
        PostBrandVisibility: action.payload
      };
    }
    case types.POST_BRAND_VISIBILITY_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
